import { Action } from "@ngrx/store";
import { ReduxAction } from "../actions/redux.action";
import { TestOrderTestSelectionSession } from "../models";

export function TestSelectionSessionReducer(
  state: TestOrderTestSelectionSession,
  action: ReduxAction
) {
  switch (action.type) {
    case "SET_TEST_ORDER_TEST_SELECTION_SESSION":
      return Object.assign({}, state, action.get());

    case "CLEAR_TEST_ORDER_SESSIONS":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/reducers/test-selection-session.reducer.ts